/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Support_QInputs */

const en_wc_faq_support_q = /** @type {(inputs: Wc_Faq_Support_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I contact WordCraftApp support?`)
};

/**
* | output |
* | --- |
* | "How do I contact WordCraftApp support?" |
*
* @param {Wc_Faq_Support_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_support_q = /** @type {((inputs?: Wc_Faq_Support_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Support_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_support_q(inputs)
});
export { wc_faq_support_q as "wc.faq.support.q" }